











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Map from '@/components/parts/Map.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import { StatusParameter } from '@/models/status/statusparameter';

@Component({
  components: {
    Map,
    CharacterIcon,
  },
})
export default class StatusParametersPanel extends Vue {
  @Prop() public parameters!: StatusParameter[];
}
